const promotionFilterConfig = window.$feconfig?.promotion?.filter
const kwkIds = window.$feconfig?.promotion?.kwkIds ? window.$feconfig?.promotion?.kwkIds : []
const activationIds = window.$feconfig?.promotion?.activationIds ? window.$feconfig?.promotion?.activationIds : []

const promotionFilter = function (promotions) {
  if (!Array.isArray(promotionFilterConfig) || promotionFilterConfig.length === 0 || !Array.isArray(promotions)) {
    return promotions
  }
  return promotions.filter(promo => {
    if (promo.requiredParameters && promo.requiredParameters.includes('promoCode')) {
      return true // include promotions that require a promo code
    } else if (kwkIds.includes(promo.promotionId)) {
      return true // include kwk promotions
    } else if (activationIds.includes(promo.promotionId)) {
      return true // include kwk promotions
    } else {
      return promotionFilterConfig.includes(promo.promotionId) // include promotions that are in the filter config
    }
  })
}

export {
  promotionFilter
}
